/**
 * The main api service
 */
import http from '@util/http';
import {incubator} from '@api/req';

export async function queryIncuAddressList(params) {
  return http.get(incubator.INCUBATOR_ADDRESS_LIST, params);
}

export async function queryIncuAddressInfo(params) {
  return http.get(incubator.INCUBATOR_ADDRESS_INFO, params);
}

export async function queryBatchIncuAddress(params) {
  return http.post(incubator.INCUBATOR_ADDRESS_BATCH, params);
}

export async function querySaveIncuAddress(params) {
  return http.post(incubator.INCUBATOR_ADDRESS_SAVE, params);
}

export async function queryDeleteIncuAddress(params) {
  return http.get(incubator.INCUBATOR_ADDRESS_DELETE, params);
}

export async function queryIncuAddressStatistic(params) {
  return http.get(incubator.INCUBATOR_ADDRESS_STATISTIC, params);
}

export async function queryIncuAddressCount(params) {
  return http.get(incubator.INCUBATOR_ADDRESS_COUNT, params);
}

// 地址使用情况
export async function queryAddressBusinessList(params) {
  return http.get(incubator.ADDRESS_BUSINESS_LIST, params);
}

// 地址使用情况统计
export async function queryAddressBusinessStatis(params) {
  return http.get(incubator.ADDRESS_BUSINESS_STATIS, params);
}

// 地址释放
export async function queryAddressLiberate(params) {
  return http.get(incubator.ADDRESS_BUSINESS_LIBERATE, params);
}



// WEBPACK FOOTER //
// ./src/api/incubator/address.js